import * as React from "react";

function MouseScrollIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={40}
      fill="none"
      viewBox="0 0 25 40"
      role="img"
      aria-label={"scroll mouse icon"}
    >
      <rect width={24} height={39} x={0.5} y={0.5} stroke="#fff" rx={12} />
      <path fill="#fff" d="M12 8h1v8h-1z">
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="translate"
          values="0 0; 0 0; 0 14; 0 14; 0 0; 0 0"
          keyTimes="0; 0.05; 0.6; 0.7; 0.95; 1"
          dur="3s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
}

export default MouseScrollIcon;
